module.exports = __webpack_public_path__ + "static/media/hospital-symbol.3c6a04dd.svg";